
<input
  type="text"
  :placeholder="placeholder"
  :value="textValue"
  :name="name"
  :maxlength="maxlength"
  @change="change"
>
